import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@Thread-Magic/jasmine';
import { ReactComponent as DownloadIcon } from 'src/assets/icons/download.svg';
import * as Styled from './style';

const MacDownload = ({ history }) => {
  const downloadMac = () => {
    window.open(
      'https://docs.getthread.com/article/5h71x2m1jq-deploying-messenger-to-mac',
      '_blank'
    );
  };

  return (
    <Styled.Wrapper>
      <>
        <Styled.Title>Deploy Mac app</Styled.Title>
        <Styled.ButtonLink onClick={downloadMac}>
          Learn more about Mac app deployment
        </Styled.ButtonLink>
        <Styled.Content>
          <Styled.SubTitle>Download the Mac app</Styled.SubTitle>
          <p>
            Messenger is available as a dmg for Mac for easy deployment via shell script or for mass
            deployment via your favorite RMM, MDM, or other deployment solution.
          </p>
          <Button size="large" styleMode="outline" onClick={downloadMac}>
            <DownloadIcon width={20} height={20} /> Download the Mac app
          </Button>
        </Styled.Content>

        <Styled.Footer>
          <Styled.ButtonLink
            size="large"
            onClick={() => {
              // NB: for some reason, we need to go back two steps to see the plataform selection page (the previous page)
              history.go(-2);
            }}
          >
            <strong>Previous</strong>
          </Styled.ButtonLink>
        </Styled.Footer>
      </>
    </Styled.Wrapper>
  );
};

MacDownload.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired
};

export default MacDownload;
